// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","917":"component---src-pages-setting-tsx"}[chunkId] + "-" + {"245":"15ba15c5289ff6b79a2c","453":"a7071bcd6fd14f4a6414","917":"109152b3e8f6d9581ee3"}[chunkId] + ".js";
};